export default function Form(handle, {
    activeClass,
}) {
    const buttons = handle.querySelectorAll('button');
    const body = document.querySelector('body');

    function handleButtons(e) {
        const button = e.target;
        const theme = button.getAttribute('data-theme');

        buttons.forEach(o => {
            o.classList.remove(activeClass);
        });
        button.classList.add(activeClass);

        body.setAttribute('data-theme', theme);
    }
    
    buttons.forEach(o => {
        o.addEventListener('click', handleButtons);
    });

    // set default
    body.setAttribute('data-theme', 'a');
    handle.querySelector('button[data-theme="a"').classList.add(activeClass);
}
